export default __webpack_public_path__ + "static/media/proj3.e9bcde12.png";